export default __webpack_public_path__ + "d1026bd.png";